import { css, styled } from 'styled-components';

/**
 * @package
 */
export const RecommendationsContainerForProjects = styled.div`
  ${({ theme }) => css`
    width: 100vw;
    background-color: ${theme.colorsV2.gray20};

    ${theme.mediaQueries.sm} {
      border-radius: 10px;
      width: 100%;
    }
  `}
`;

/**
 * @package
 */
export const RecommendationsContainerForServices = styled.div`
  ${({ theme }) => css`
    width: 100vw;
    background-color: ${theme.colorsV2.gray05};

    ${theme.mediaQueries.sm} {
      border-radius: 10px;
      width: 100%;
    }
  `}
`;
